import { Navigate } from 'react-router-dom';
import { useGetLojaAtualQuery } from '../../api';

/**
 * Entrada quando o cliente acessa `/checkout/<uuid>` (mesa/comanda).
 * O tenant e o carrinho persistido já foram resolvidos pelo
 * `TenantBootstrap`; aqui só redireciona para o catálogo.
 */
export function CheckoutPage(): JSX.Element {
  const { data } = useGetLojaAtualQuery();

  if (!data) return <></>;
  return <Navigate to="/catalogo" replace />;
}
